/** Maps backend `language` (ISO 639-1) to Vue I18n locale codes used in this app. */
export function mapUserLanguageToI18nLocale(
  lang: string | null | undefined,
): 'de' | 'en' {
  const s = lang?.trim().toLowerCase()
  if (s === 'en') return 'en'
  return 'de'
}
